import { put, takeLatest } from 'redux-saga/effects';
import httpClient from '../../../utils/http-client';
import { handleError } from '../../../utils/utils';
import { fetchInvoicesSummariesFailure, fetchInvoicesSummariesSuccess } from '../actions';
import invoiceSummariesActionTypes from '../types';

export function* fetchInvoicesSummaries({ payload }) {
  let endpoint = '/invoice-summaries';

  try {
    const response = yield httpClient.get(endpoint, { params: payload });
    yield put(fetchInvoicesSummariesSuccess(response.data));
  } catch (error) {
    yield put(fetchInvoicesSummariesFailure(error?.message));
    const err = handleError(error);
  }
}

export function* onfetchInvoicesSummariesStart() {
  yield takeLatest(
    invoiceSummariesActionTypes.FETCH_STUDENT_INVOICES_SUMMARIES_START,
    fetchInvoicesSummaries,
  );
}
